export default __webpack_public_path__ + "static/media/kycVerificationhelpMobileHighlight.ea71448e.png";